import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import jobseekersService from 'features/jobseekers/jobseekersService';

import { EducationAndWorkExperience } from 'types/commons';

import useErrorCatch from './useErrorCatch';

interface useFetchEducationAndExperienceProps {
  jobseekerId?: string | null;
}

export const useFetchEducationAndExperience = ({
  jobseekerId
}: useFetchEducationAndExperienceProps) => {
  const { t } = useTranslation();
  const catchError = useErrorCatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<EducationAndWorkExperience | null>(null);

  const fetchData = async (jobseekerId: string): Promise<void> => {
    try {
      setIsLoading(true);
      const result =
        await jobseekersService.getJobseekerEducationAndWorkExperience(
          jobseekerId
        );

      setData(result);
    } catch (error) {
      catchError({
        error,
        default: {
          message: t('error.message.operationFailed'),
          description: t('error.message.fetchJobseekerEducation')
        }
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setData(null);

    if (!jobseekerId) {
      return;
    }

    fetchData(jobseekerId);
  }, [jobseekerId]);

  return {
    data,
    isLoading
  };
};
